export default __webpack_public_path__ + "images/247f49bb2c7401e1654f9de997854cb2-austin_mobile.webp";